import React, { memo } from 'react'

import RewardMember from './RewardMember'

const RewardPointsBankMember = (props) => {
  return <RewardMember accountLabel='reward.member-email' {...props} />
}

export default memo(RewardPointsBankMember)
